<template>
  <div class="compose_left">
    <el-menu :default-active="index">
      <el-menu-item index="1" @click="$router.push('/console/index')">
        <img src="~@/assets/images/icon-compose-left1.png" alt="" />
        <span slot="title">我的主页</span>
      </el-menu-item>
      <el-menu-item index="2" @click="$router.push('/console/list')">
        <img src="~@/assets/images/icon-compose-left2.png" alt="" />
        <span slot="title">我的创作</span>
      </el-menu-item>
      <!-- <el-menu-item index="3" @click="$router.push(encodeURI('/我的素材'))">
        <img src="~@/assets/images/icon-compose-left3.png" alt="" />
        <span slot="title">我的素材</span>
      </el-menu-item>
      <el-menu-item index="4" @click="$router.push(encodeURI('/我的模板'))">
        <img src="~@/assets/images/icon-compose-left4.png" alt="" />
        <span slot="title">我的模板</span>
      </el-menu-item> -->
      <el-menu-item index="5" @click="$router.push('/console/history')">
        <img src="~@/assets/images/icon-compose-left5.png" alt="" />
        <span slot="title">最近修改</span>
      </el-menu-item>
      <el-menu-item index="6" @click="$router.push('/console/trash')">
        <img src="~@/assets/images/icon-compose-left6.png" alt="" />
        <span slot="title">回收站</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      templateList: [],
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/compose.scss";
</style>
